import { render, staticRenderFns } from "./layout-cooperation-main.vue?vue&type=template&id=201d3074&scoped=true"
import script from "./layout-cooperation-main.vue?vue&type=script&lang=js"
export * from "./layout-cooperation-main.vue?vue&type=script&lang=js"
import style0 from "./layout-cooperation-main.vue?vue&type=style&index=0&id=201d3074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d3074",
  null
  
)

export default component.exports